module.exports = __webpack_public_path__ + "img/3.3535e281.jpg";